import { RDLiming } from '@cibo/core'
import { EventDetailEditorSimple } from '../EventDetail'
import { DetailEditorPropsByYear } from '../types'
import { LimingEventEditorSimple } from './LimingEventEditorSimple'

export const LimingEditorSimple = ({
  fieldModels,
  year,
  name = 'limingEditor',
  requirement,
  filterInputs,
  traitId,
}: DetailEditorPropsByYear) => (
  <EventDetailEditorSimple<RDLiming['input']>
    traitId={traitId}
    fieldModels={fieldModels}
    year={year}
    name={name}
    requirement={requirement}
    filterInputs={filterInputs}
    EventComponent={LimingEventEditorSimple}
    translationContext="liming"
    defaultEvent={{ date: null, amount: '', unit: '' }}
  />
)
